"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("../..");
exports.integration = graphql_tag_1.default `
  query integration($id: ID!) {
    integration(id: $id) {
      ...mailjetDetailData
      ...sailthruDetailData
      ...salesforceDetailData
      ...contentSystemDetailData
      ...mailchimpDetailData
      ...campaignMonitorDetailData
      ...activeCampaignDetailData
    }
  }
  ${graphql_1.mailjetDetailData}
  ${graphql_1.contentSystemDetailData}
  ${graphql_1.sailthruDetailData}
  ${graphql_1.salesforceDetailData}
  ${graphql_1.mailchimpDetailData}
  ${graphql_1.campaignMonitorDetailData}
  ${graphql_1.activeCampaignDetailData}
`;
exports.integrations = graphql_tag_1.default `
  query integrationsQuery($skip: Int, $take: Int, $integrationTypes: [String!]) {
    integrationsCount(integrationTypes: $integrationTypes)
    integrations(skip: $skip, take: $take, integrationTypes: $integrationTypes) {
      ...mailjetListData
      ...sailthruListData
      ...salesforceListData
      ...contentSystemListData
      ...mailchimpDetailData
      ...campaignMonitorDetailData
      ...activeCampaignDetailData
    }
  }
  ${graphql_1.mailjetListData}
  ${graphql_1.contentSystemListData}
  ${graphql_1.sailthruListData}
  ${graphql_1.salesforceListData}
  ${graphql_1.mailchimpDetailData}
  ${graphql_1.campaignMonitorDetailData}
  ${graphql_1.activeCampaignDetailData}
`;
exports.campaignMonitorClients = graphql_tag_1.default `
  query campaignMonitorClients($id: ID!) {
    campaignMonitorClients(id: $id) {
      id
      name
    }
  }
`;
exports.espAdapterRequest = graphql_tag_1.default `
  query espAdapterRequest($id: ID!, $fn: String!, $data: String) {
    espAdapterRequest(id: $id, fn: $fn, data: $data)
  }
`;
exports.salesforceCategories = graphql_tag_1.default `
  query salesforceCategories(
    $fallbackCount: Float,
    $integrationId: ID!,
    $skip: Int,
    $take: Int,
    $pageSize: Int,
    $page: Int,
    $searchQuery: String,
    $categoryType: String
  ) {
    salesforceCategories(
      fallbackCount: $fallbackCount,
      integrationId: $integrationId,
      pageSize: $pageSize,
      page: $page,
      skip: $skip,
      take: $take,
      searchQuery: $searchQuery,
      categoryType: $categoryType
    ) {
      edges {
        ...salesforceCategoryData
      }
      count
    }
  }
  ${graphql_1.salesforceCategoryData}
`;
exports.salesforceSendClassifications = graphql_tag_1.default `
  query salesforceSendClassifications(
    $integrationId: ID!
  ) {
    salesforceSendClassifications(
      integrationId: $integrationId
    ) {
      edges {
        ...salesforceSendClassificationData
      }
      count
    }
  }
  ${graphql_1.salesforceSendClassificationData}
`;
//# sourceMappingURL=integrations.js.map